// Utilitários de validação de formulários

export const validarCPF = (cpf: string): boolean => {
  // Remove caracteres não numéricos
  const cpfLimpo = cpf.replace(/[^\d]/g, '');
  
  // Verifica se tem 11 dígitos
  if (cpfLimpo.length !== 11) return false;
  
  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(cpfLimpo)) return false;
  
  // Validação do primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpfLimpo.charAt(i)) * (10 - i);
  }
  let resto = 11 - (soma % 11);
  let digitoVerificador1 = resto >= 10 ? 0 : resto;
  
  if (digitoVerificador1 !== parseInt(cpfLimpo.charAt(9))) return false;
  
  // Validação do segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpfLimpo.charAt(i)) * (11 - i);
  }
  resto = 11 - (soma % 11);
  let digitoVerificador2 = resto >= 10 ? 0 : resto;
  
  return digitoVerificador2 === parseInt(cpfLimpo.charAt(10));
};

export const validarTelefone = (telefone: string): boolean => {
  // Remove caracteres não numéricos
  const telefoneLimpo = telefone.replace(/[^\d]/g, '');
  
  // Verifica se tem 10 ou 11 dígitos (com DDD)
  return telefoneLimpo.length === 10 || telefoneLimpo.length === 11;
};

export const validarEmail = (email: string): boolean => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export const validarArquivo = (
  arquivo: File,
  tiposPermitidos: string[],
  tamanhoMaximoMB: number
): { valido: boolean; erro?: string } => {
  // Valida tipo de arquivo
  const tipoValido = tiposPermitidos.some(tipo => 
    arquivo.type.includes(tipo) || arquivo.name.toLowerCase().endsWith(tipo)
  );
  
  if (!tipoValido) {
    return {
      valido: false,
      erro: `Tipo de arquivo não permitido. Tipos aceitos: ${tiposPermitidos.join(', ')}`
    };
  }
  
  // Valida tamanho do arquivo
  const tamanhoMaximoBytes = tamanhoMaximoMB * 1024 * 1024;
  if (arquivo.size > tamanhoMaximoBytes) {
    return {
      valido: false,
      erro: `Arquivo muito grande. Tamanho máximo: ${tamanhoMaximoMB}MB`
    };
  }
  
  return { valido: true };
};

export const formatarCPF = (cpf: string): string => {
  const cpfLimpo = cpf.replace(/[^\d]/g, '');
  return cpfLimpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

export const formatarTelefone = (telefone: string): string => {
  const telefoneLimpo = telefone.replace(/[^\d]/g, '');
  if (telefoneLimpo.length === 11) {
    return telefoneLimpo.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }
  return telefoneLimpo.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
};

export const validarCampoObrigatorio = (valor: string): boolean => {
  return valor.trim().length > 0;
};

export const validarTextoMinimo = (texto: string, minimo: number): boolean => {
  return texto.trim().length >= minimo;
};

export const validarTextoMaximo = (texto: string, maximo: number): boolean => {
  return texto.trim().length <= maximo;
};
